module.exports = __webpack_public_path__ + "img/FamilyMartlogo.cb94157e.svg";